import Component from "../../lib/Component.js";

const CMP = ({ onConsent }) => {
  // Make sure that the properties exist on the window.
  window.googlefc = window.googlefc || {};
  window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];

  const isGranted = (status) => {
    const {
      CONSENT_MODE_PURPOSE_STATUS_GRANTED,
      CONSENT_MODE_PURPOSE_STATUS_NOT_APPLICABLE,
      CONSENT_MODE_PURPOSE_STATUS_NOT_CONFIGURED,
    } = window.googlefc.ConsentModePurposeStatusEnum;
    return [
      CONSENT_MODE_PURPOSE_STATUS_GRANTED,
      CONSENT_MODE_PURPOSE_STATUS_NOT_APPLICABLE,
      CONSENT_MODE_PURPOSE_STATUS_NOT_CONFIGURED,
    ].includes(status);
  };

  return new Component({
    onMount: () => {
      let resolved = false;
      const resolveOnce = (data) => {
        if (resolved) return;
        resolved = true;
        if (onConsent) onConsent(data);
      };

      window.googlefc.callbackQueue.push({
        CONSENT_MODE_DATA_READY: () => {
          const consentValues = window.googlefc.getGoogleConsentModeValues();
          const analytics = isGranted(consentValues.analyticsStoragePurposeConsentStatus);
          const ads =
            isGranted(consentValues.adStoragePurposeConsentStatus) &&
            isGranted(consentValues.adUserDataPurposeConsentStatus) &&
            isGranted(consentValues.adPersonalizationPurposeConsentStatus);

          // Update Google Consent Mode with user's choice
          if (window.gtag) {
            window.gtag("consent", "update", {
              ad_storage: ads ? "granted" : "denied",
              ad_user_data: ads ? "granted" : "denied",
              ad_personalization: ads ? "granted" : "denied",
              analytics_storage: analytics ? "granted" : "denied",
              functionality_storage: analytics ? "granted" : "denied",
              personalization_storage: analytics ? "granted" : "denied",
            });
          }

          resolveOnce({ analytics, ads, reason: "consent-ready" });
        },
      });

      // If the Google CMP script is blocked (e.g. by an ad blocker),
      // window.googlefc will never be populated with the library's Enums.
      // We wait 2 seconds for the script to at least initialize.
      // Skip this timeout in development mode to avoid redundant logs
      // when withDevModeFailover is already being used.
      if (process.env.NODE_ENV === "development") {
        return;
      }

      setTimeout(() => {
        if (!resolved && !(window.googlefc && window.googlefc.ConsentModePurposeStatusEnum)) {
          console.warn("CMP script blocked or failed to load - using failover values");
          resolveOnce({ analytics: false, ads: false, reason: "cmp-blocked" });
        }
      }, 2000);
    },
  });
};

export default CMP;
